var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpiloticon = function SvgTrustpiloticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b67a",
    d: "M49.518 19.505H30.793L25.009 1.684l-5.802 17.821-18.725-.018 15.164 11.025-5.802 17.803 15.164-11.007 15.146 11.007-5.784-17.803 15.146-11.007z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005128",
    d: "m35.673 34.543-1.301-4.031-9.362 6.796z"
  })));
};
export default SvgTrustpiloticon;